import { useEffect, useState } from 'react'; // , useContext
// import { Link } from 'react-router-dom';
import DisplayContactForm from '../../components/DisplayContactForm';
import axiosInstance from "../../helpers/Axios";

const defaultList: ICourseObj[] = [];

interface IDay {
  name: string;
}

interface ICourse {
  shortName: string;
  name: string;
  day: IDay;
  isVisible: boolean;
  startTime: string;
  endTime: string;
}


interface IContact {
  contactId: number,
  firstName: string,
  lastName: string
}

interface ICourseObj {
  course: ICourse;
  subscribes: IContact[];
}


const Contact = () => {

  const [list, setList] = useState(defaultList);
  const [visible, setVisible] = useState(true);
  const loading = list === defaultList && visible;
  
useEffect(() => {
  if(loading)
    axiosInstance.get("/course")
      .then(response => {
        //console.log('response', response);

        setList(response.data);//.map((courseObj : ICourseObj) => courseObj.course))
        // console.log("réponse",response.data);
        // setUserProfile(response.data);
        // setLocation(response.data.location);
      })
      .catch((err) => {
        const error = err.response === undefined ?
          'Server in not reachable'
          : err.response.data;
        console.log('error', error);
        setVisible(false);
      });
    }
 );

//  console.log("list",list);

  return (
    <div id="courses">
      <div id="title">
        <h1>Mail groupé aux étudiants d'un cours</h1>
      </div>
      <div id="content">
        {
        loading ?
        <p>Chargement en cours...</p>
        :
        visible ?
          <DisplayContactForm stages={undefined} courses={list} title="Choisir votre cours"/>
          :
            <div>
              <p>Le système d'inscription est actuellement en panne.</p>
            </div>
            }
      </div>
    </div>
  )
};

export default Contact;
